import { useNavigate } from 'react-router'
import { TabBar } from 'antd-mobile'
import { useCorpInfoStore } from '@/stores'

import { t } from '@/utils/i18n'
import Icon from '@/components/Icon/Icon'
import styles from './index.module.less'

interface IProps {
  activeKey?: string
}

function TabbarAlbum(props: IProps) {
  const { activeKey = 'Album' } = props
  const navigate = useNavigate()
  const { corpInfo } = useCorpInfoStore()
  const { corpId } = corpInfo

  const tabs = [
    {
      key: 'Album',
      title: t('新品2'),
      icon: <Icon name="home" />,
      iconActive: <Icon name="home-active" color="#FE5700" />,
      path: `/album/${corpId}`,
    },
    {
      key: 'AlbumCategory',
      title: t('商品分类'),
      icon: <Icon name="unorder" />,
      iconActive: <Icon name="unorder-active" color="#FE5700" />,
      path: `/album/${corpId}/category`,
    },
  ]

  // 切换tab
  function onKeyChange(key: string) {
    const findResult = tabs.find((item) => item.key === key)

    if (!findResult) {
      return
    }

    const { path } = findResult

    navigate(path, { replace: true })
  }

  return (
    <TabBar
      activeKey={activeKey}
      onChange={onKeyChange}
      className={styles['tabbar']}
    >
      {tabs.map((item) => (
        <TabBar.Item
          key={item.key}
          icon={item.key === activeKey ? item.iconActive : item.icon}
          title={item.title}
        />
      ))}
    </TabBar>
  )
}

export default TabbarAlbum
